import type { Component } from 'solid-js'
import { createMemo, For } from 'solid-js'
import { useTransContext } from '@mbarzda/solid-i18next'
import type { SectionMetrics } from '../../../features/engagement/domain/models/sections'
import { ChartContainerWithHeader, useChart } from '../../shared/charts'
import { formatDurationHours } from './section-display'
import { getSectionsTimeDonutItems, getSectionsTimeDonutOptions } from './SectionsTimeDonut.vm'

interface SectionsTimeDonutProps {
  sections: SectionMetrics[]
}

const SectionsTimeDonut: Component<SectionsTimeDonutProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const [t] = useTransContext()

  const donutItems = createMemo(() => getSectionsTimeDonutItems(props.sections, t))

  useChart({
    data: () => donutItems(),
    chartRef: () => chartRef,
    buildOptions: (items) => getSectionsTimeDonutOptions(items)
  })

  return (
    <ChartContainerWithHeader hasData={donutItems().length > 0} title={t('ls_sections_time_donut_title')}>
      <div class="flex h-full items-center gap-4">
        <div class="flex flex-[1.5] items-center justify-center">
          <div ref={chartRef} class="w-full" />
        </div>
        <div class="flex flex-1 flex-col gap-3">
          <For each={donutItems()}>
            {(item) => (
              <div class="flex items-center justify-between gap-4">
                <div class="flex min-w-0 items-center gap-2">
                  <div class="h-2.5 w-2.5 flex-shrink-0 rounded-full" style={{ 'background-color': item.color }} />
                  <span class="text-sm font-medium text-gray-500">{item.name}</span>
                </div>
                <span class="flex-shrink-0 text-sm font-bold text-gray-900">{formatDurationHours(item.value)}</span>
              </div>
            )}
          </For>
        </div>
      </div>
    </ChartContainerWithHeader>
  )
}

export default SectionsTimeDonut
